module.exports = __webpack_public_path__ + "static/media/renzo.4c1da13e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/renzo.svg
// module id = 475
// module chunks = 0